export type RegisterActionMessages = {
  registerAction: string;
  alreadyHaveAnAccount: string;
  clickText: string;
  agreeTo: string;
  termsOfService: string;
  andText: string;
  privacyPolicy: string;
};

export const REGISTER_ACTION_MESSAGES: RegisterActionMessages = {
  registerAction: "Registrar",
  alreadyHaveAnAccount: "Já possui uma conta?",
  clickText: "Clique aqui",
  agreeTo: "Concordo com os",
  termsOfService: "termos de serviço",
  andText: "e",
  privacyPolicy: "política de privacidade.",
};
